/* eslint-disable no-restricted-imports */
import { createPlugin } from '../../../Fct/createPlugin';
import { FctString } from '../../../Fct/generics';
export var Alert = createPlugin({
    protocol: 'FUNCTIONS',
    type: 'GETTER',
    method: 'alert',
    name: 'alert',
    flowType: 'OFFCHAIN_ONLY',
    initParams: {
        type: 'onError'
    },
    getParams: function () { return ({
        input: {
            type: new FctString({
                options: [
                    { value: 'onError', name: 'onError' },
                    { value: 'onSuccess', name: 'onSuccess' },
                    { value: 'onAny', name: 'onAny' },
                ],
            }),
            alert: new FctString({ required: true }),
            methodParams: {},
        },
        output: {},
    }); },
});
